import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './choice.json';

const Choice = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Decision-making, options, and consumer choice vocabulary. B2 level English exercises with grammar, reading, and discussion."
            level="B2"
            title="Choice"
            image="/Images/choice1.webp"
            seoTitle="Free English Lesson Plans: Choice"
            seoDescription="Decision-making, options, and consumer choice vocabulary. B2 level English exercises with grammar, reading, and discussion."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Choice;


